module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tablet-en.bbb61858.png";